import script from "./EducationScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./EducationScreen.vue?vue&type=script&setup=true&lang=js"

import "./EducationScreen.vue?vue&type=style&index=0&id=aeabb18c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aeabb18c"]])

export default __exports__